import React, { useState } from 'react'
import { getImages } from '../const'

const MobPmtDetails = ({ 
        close, 
        openMobPmtModal, 
        mobPmtData, 
        filters, 
        handlePriceBtn,
        numberFormatter,
        appraisalData,
        isWholesale
    }) => {
        const [fetchingData, setFetchingData] = useState(false);
        const getPriceDiff = (vehicle) => {
            return vehicle.price - (appraisalData && vehicle.vin in appraisalData ? (isWholesale ? appraisalData[vehicle.vin].appraisal : appraisalData[vehicle.vin].avg_retail) : 0);
        }
        const priceDiff = getPriceDiff(mobPmtData);
    return (
        <>
            {console.log("mobPmtData", mobPmtData)}
            <div className={`mob-custom-modal mob-pmt-modal ${openMobPmtModal ? "open" : ""}`}>
                <div className="d-flex d-lg-none align-items-center justify-content-between mob-custom-header w-100">
                    <div className="mob-header-title">Price Mismatches</div>
                    <div>
                        <button className="sm-box-close mt-0" type="button" onClick={close}>
                            <img src={getImages('white-close.svg')} alt="Close" />
                        </button>
                    </div>
                </div>
                <div className="mob-custom-body p-0">
                    <div>
                        <button type="button" className="back-transparent-btn py-3 px-3" onClick={close}>{`<`} Back to all Results</button>
                    </div>
                    <div>
                        <img src={mobPmtData.image} alt=''/>
                    </div>
                    <div className='py-3 px-3'>
                        <div className='sm-title fw-600 font-1-2em mb-2'>{mobPmtData.title}</div>
                        <div className='xs-title font-14 text-lred ocrastd mb-2'>{mobPmtData.vin}</div>
                        <div className='d-flex align-items-center justify-content-between'>
                            <div className='xsm-title'>{mobPmtData.mileage?.toLocaleString()} miles</div>
                            <div className='xsm-title'><span className='fw-700 text-white'>{mobPmtData.dom_is}</span> Days on Lot</div>
                        </div>
                    </div>
                    <div className='py-3 px-3 mob-border-y'>
                        <div className='d-flex align-items-center justify-content-between'>
                            <div>
                                <div className='xs-title mb-1'>
                                    <a className='text-white text-capitalize text-ellips' href={'/dealer-analysis?dealership=' + encodeURIComponent(mobPmtData.dealership)} target="_blank">
                                        <span className='pmt-label'>{mobPmtData.dealership}</span>
                                    </a>
                                </div>
                                <div className='xsm-title'>{mobPmtData.location}</div>
                            </div>
                            <div>
                                {/* {filters.zipCode &&
                                    <div className='d-inline-block xsm-title'><img src={getImages('icon-pin.png')} />
                                        <span className='fw-700 text-white ps-1'>{filters.milesZipCode}</span> miles from <span className='fw-700 text-red'>{filters.zipCode}</span>
                                    </div>
                                } */}
                                <div className='d-inline-block xsm-title'><img src={getImages('icon-pin.png')} />
                                    <span className='fw-700 text-white ps-1'>50</span> miles from <span className='fw-700 text-red'>{filters.zipCode}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='py-5 px-3'>
                        <div className='text-center mb-4'>
                            <button className='text-uppercase d-inline-block transparent-btn text-nowrap mnw-210 mob-pmt-wholesale-btn text-lred' type='button' onClick={handlePriceBtn}>
                                {'Wholesale/Retail'}
                                <img className='ms-3' src={getImages('loop-material.png')} />
                            </button>
                        </div>
                        <div className='text-center text-nowrap'>
                            <div className='d-inline-flex'>
                                <div className='px-3 px-sm-5 mob-right-border'>
                                    <div className='xs-title mob-font-12 text-center mb-2'>List Price</div>
                                    <div className='text-center font-1-32em fw-700 avenir text-white'>{numberFormatter(mobPmtData.price, true)}</div>
                                </div>
                                <div className='px-3 px-sm-5 mob-right-border'>
                                    <div className='xs-title mob-font-12 text-center mb-2'>Avg Retail Price</div>
                                    <div className='text-center font-1-32em fw-700 avenir text-white'>
                                        {appraisalData && mobPmtData.vin in appraisalData && appraisalData[mobPmtData.vin].appraisal && appraisalData[mobPmtData.vin].avg_retail ?
                                            (numberFormatter(isWholesale ? appraisalData[mobPmtData.vin].appraisal : appraisalData[mobPmtData.vin].avg_retail, true)) : (
                                                fetchingData ?
                                                    <div className="float-points">
                                                        <div className="dot-collision"></div>
                                                    </div>
                                                    :
                                                    "-"
                                            )}
                                    </div>
                                </div>
                                <div className='px-3 px-sm-5'>
                                    <div className='xs-title mob-font-12 text-center mb-2'>Difference</div>
                                    <div className={`text-center font-1-32em fw-700 avenir text-start ${priceDiff <= 0 ? 'text-green' : 'text-red'}`}>
                                        {appraisalData && mobPmtData.vin in appraisalData && appraisalData[mobPmtData.vin].appraisal && appraisalData[mobPmtData.vin].avg_retail ?
                                            <>
                                                <img className='me-1' src={getImages(priceDiff <= 0 ? 'arrow-green-down.png' : 'arrow-red-down.png')} /> {numberFormatter(priceDiff, true)}
                                            </>
                                            :
                                            (
                                                fetchingData ?
                                                    <div className="float-points">
                                                        <div className="dot-collision"></div>
                                                    </div>
                                                    :
                                                    "-"
                                            )
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='text-center mt-60'>
                            {mobPmtData.vdp_url ? <a href={mobPmtData.vdp_url} className='red-btn w-100 fw-700 text-white text-uppercase d-block' target="_blank">View Vehicle Details</a> : <span></span>}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default MobPmtDetails